import { defineFcm } from '../shared/factory';

export const FCM_COMMS_STACK_AUTO_AA_ML_ALLOWED_COUNTRIES = defineFcm('comms_stack_auto_aa_ml_allowed_countries')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'comms-stack',
		context: 'comms stack',
		description: 'Controls whether auto_aa_ml messages should be sent',
		import: false,
	});
